import { tag } from "../typeUtils.mjs";
import { createContext, useContext } from "react";

//#region src/hooks/useRequiredContext.ts
function createNamedContext(name, initialValue) {
	const context = createContext(initialValue);
	context.displayName = name;
	return tag(context);
}
function useRequiredContext(context) {
	const value = useContext(context);
	if (!value) throw new Error(`Tried to access ${context.displayName} context outside of a provider`);
	return value;
}

//#endregion
export { createNamedContext, useRequiredContext };